import React from 'react';

import { Visualiser } from '../Visualiser';

import { PersonalisationHeader } from '../PersonalisationHeader';
import { PersonalisationStep } from '../PersonalisationStep';
import { PersonalisationFooter } from '../PersonalisationFooter';
import { PersonalisationLoader } from '../PersonalisationLoader';
import { useViewModel } from './useViewModel';

import styles from './personalisation-modal.module.css';

/**
 * PersonalisationModal handles the product personalisation flow, including step navigation.
 * Only the current step is rendered at a time.
 *
 * @param {Object} props - Component props
 * @param {boolean} props.isOpen - Whether the modal is open
 * @param {function} props.onClose - Callback for closing the modal
 * @returns {import('react').JSX.Element}
 */
export function PersonalisationModal({ isOpen, onClose }) {
  const {
    dialogModalRef,
    contentRef,
    totalSteps,
    currentStep,
    handleClose,
    handleNext,
    handlePrev,
    handleReset,
    headerTitle,
    headerResetText,
    isResetting,
    isAddingToCart,
    isRetrying
  } = useViewModel({ isOpen, onClose });

  return (
    <dialog ref={dialogModalRef} closedby="any" className={styles['personalisation__modal']}>
      <PersonalisationLoader isVisible={isAddingToCart} isRetrying={isRetrying} />
      <PersonalisationHeader
        title={headerTitle}
        resetText={headerResetText}
        onClose={handleClose}
        totalSteps={totalSteps}
        currentStep={currentStep}
        onReset={handleReset}
        isResetting={isResetting}
      />
      <Visualiser width={800} />
      <div ref={contentRef} className={styles['personalisation__content']}>
        <PersonalisationStep />
      </div>
      <PersonalisationFooter
        onClose={handleClose}
        totalSteps={totalSteps}
        currentStep={currentStep}
        onNext={handleNext}
        onPrev={handlePrev}
      />
    </dialog>
  );
}
